import { useForgotPassword } from "@qw/auth";
import { Link } from "react-router";
import { z } from "zod";
import { Button } from "../button";
import { CardContent, CardFooter } from "../card";
import { FieldInput, Form, FormSubmit } from "../form";
import { Group } from "../group";
import { AuthCard } from "./auth-card";

const validationSchema = z.object({
  email: z.string().email({ message: "Please enter a valid email address" }),
});

const defaultValues = {
  email: "",
};

export const AuthForgotPassword = () => {
  const [forgotPassword, { error, data }] = useForgotPassword();

  const handleSubmit = async (formData: z.infer<typeof validationSchema>) =>
    await forgotPassword({ variables: formData });

  if (data?.forgotPassword) {
    return (
      <AuthCard header="Success!" subHeader="Please check your inbox.">
        <CardContent>
          <Button variant="link" asChild>
            <Link to="..">&larr; Go back to login</Link>
          </Button>
        </CardContent>
      </AuthCard>
    );
  }

  return (
    <Form validationSchema={validationSchema} defaultValues={defaultValues} onSubmit={handleSubmit}>
      <AuthCard
        header="Forgot password"
        subHeader="Hey, it happens to the best of us&mdash;input your email and we'll send a password reset email."
        error={error}
      >
        <CardContent>
          <FieldInput type="email" name="email" placeholder="Email" />
        </CardContent>
        <CardFooter>
          <Group className="flex-1">
            <FormSubmit disabled={false}>Send me the Email</FormSubmit>
            <Button variant="link" asChild>
              <Link to="..">&larr; Go back to login</Link>
            </Button>
          </Group>
        </CardFooter>
      </AuthCard>
    </Form>
  );
};
